export function isNumeric(value) {
    return /^(?:[1-9][0-9]*|0)$/.test(value);
}